import { Injectable } from '@angular/core';
import {
  PagedAircraftProfileAudit,
  PagedAircraftPerformanceAudit,
  PagedAircraftProfileEngineAudit,
  PagedEngineAudit,
  PagedAircraftProfileComponentAudit,
  PagedComponentAudit,
  PagedColorSettingAudit,
  PagedPostFlightVisibilityAudit,
  PagedAircraftRelationAudit,
  PagedPhoneNumberAudit,
  PagedEmailAddressAudit,
  PagedAddressAudit,
  AircraftProfileSkeleton,
  PagedAircraftBillingRateAudit
} from './+models/aircraft-profile-audit.model';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class AircraftProfileAuditService {
  constructor(private readonly http: HttpClient) {}

  getAircraftProfileAudits(
    aircraftProfileId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/AircraftProfileAudit/${aircraftProfileId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedAircraftProfileAudit>(url);
  }

  getAircraftPerformanceAudits(
    aircraftPerformanceId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/AircraftProfileAudit/AircraftPerformance/${aircraftPerformanceId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedAircraftPerformanceAudit>(url);
  }

  getAircraftProfileEngineAudits(
    aircraftProfileEngineId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/AircraftProfileAudit/AircraftProfileEngine/${aircraftProfileEngineId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedAircraftProfileEngineAudit>(url);
  }

  getEngineAudits(
    engineId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/AircraftProfileAudit/Engine/${engineId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedEngineAudit>(url);
  }

  getAircraftProfileComponentAudits(
    aircraftProfileComponentId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/AircraftProfileAudit/AircraftProfileComponent/${aircraftProfileComponentId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedAircraftProfileComponentAudit>(url);
  }

  getComponentAudits(
    componentId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/AircraftProfileAudit/Component/${componentId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedComponentAudit>(url);
  }

  getColorSettingAudits(
    colorSettingId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/AircraftProfileAudit/ColorSetting/${colorSettingId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedColorSettingAudit>(url);
  }

  getAircraftPostflightVisibilityAudits(
    postflightVisibilityId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/AircraftProfileAudit/PostFlightVisibility/${postflightVisibilityId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedPostFlightVisibilityAudit>(url);
  }

  getAircraftBillingRateAudits(
    aircraftBillingRateId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/AircraftProfileAudit/AircraftBillingRate/${aircraftBillingRateId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedAircraftBillingRateAudit>(url);
  }

  getAircraftRelationAudits(
    aircraftRelationId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/AircraftProfileAudit/AircraftRelation/${aircraftRelationId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedAircraftRelationAudit>(url);
  }

  getPhoneNumberAudits(
    phoneNumberId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/AircraftProfileAudit/PhoneNumber/${phoneNumberId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedPhoneNumberAudit>(url);
  }

  getEmailAddressAudits(
    emailAddressId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/AircraftProfileAudit/EmailAddress/${emailAddressId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedEmailAddressAudit>(url);
  }

  getAddressAudits(
    addressId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/AircraftProfileAudit/Address/${addressId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedAddressAudit>(url);
  }

  getAircraftProfileSkeleton(aircraftProfileId: number) {
    return this.http.get<AircraftProfileSkeleton>(
      `/sdapi/profile/AircraftProfileAudit/AircraftProfileSkeleton/${aircraftProfileId}`
    );
  }
}
